var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "basic-info" },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-position": "left",
            "label-width": "80px",
            model: _vm.formLabelAlign
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "商品编码" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.formLabelAlign.self_code,
                  callback: function($$v) {
                    _vm.$set(_vm.formLabelAlign, "self_code", $$v)
                  },
                  expression: "formLabelAlign.self_code"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "锐锢商城编码" } },
            [
              _c("el-input", {
                attrs: { disabled: true },
                model: {
                  value: _vm.formLabelAlign.ruigu_code,
                  callback: function($$v) {
                    _vm.$set(_vm.formLabelAlign, "ruigu_code", $$v)
                  },
                  expression: "formLabelAlign.ruigu_code"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "商品名称" } },
            [
              _c("el-input", {
                attrs: { disabled: true },
                model: {
                  value: _vm.formLabelAlign.name,
                  callback: function($$v) {
                    _vm.$set(_vm.formLabelAlign, "name", $$v)
                  },
                  expression: "formLabelAlign.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "规格型号" } },
            [
              _c("el-input", {
                attrs: { disabled: true },
                model: {
                  value: _vm.formLabelAlign.spec,
                  callback: function($$v) {
                    _vm.$set(_vm.formLabelAlign, "spec", $$v)
                  },
                  expression: "formLabelAlign.spec"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "所属分类" } },
            [
              _c("el-input", {
                attrs: { disabled: true },
                model: {
                  value: _vm.formLabelAlign.c_name,
                  callback: function($$v) {
                    _vm.$set(_vm.formLabelAlign, "c_name", $$v)
                  },
                  expression: "formLabelAlign.c_name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "所属品牌" } },
            [
              _c("el-input", {
                attrs: { disabled: true },
                model: {
                  value: _vm.formLabelAlign.b_name,
                  callback: function($$v) {
                    _vm.$set(_vm.formLabelAlign, "b_name", $$v)
                  },
                  expression: "formLabelAlign.b_name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "最小起订量" } },
            [
              _c("el-input", {
                attrs: { disabled: true },
                model: {
                  value: _vm.formLabelAlign.start_sell,
                  callback: function($$v) {
                    _vm.$set(_vm.formLabelAlign, "start_sell", $$v)
                  },
                  expression: "formLabelAlign.start_sell"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.saveGoods }
                },
                [_vm._v("保存")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c18ac95c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c18ac95c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basic/goodsmanage/basic-info.vue
// module id = null
// module chunks = 